import { ChangeDetectionStrategy, Component, inject, linkedSignal, signal } from '@angular/core';
import { FormField, form, required } from '@angular/forms/signals';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import moment from 'moment';
import { finalize } from 'rxjs';

import { Agreement } from '../schemas';
import { AgreementService } from '../service';

export interface NextInvoiceFormData {
  agreement: Agreement;
};
@Component({
  selector: 'lcm-next-invoice-date-form',
  imports: [
    MatProgressBarModule,
    MatInputModule,
    MatDatepickerModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    FormField,
  ],
  templateUrl: './next-invoice-date-form.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: ``,
})
export class NextInvoiceDateForm {
  pending = signal(false);
  hostDialog = inject(MatDialogRef);
  agreementService = inject(AgreementService);
  data = (inject(MAT_DIALOG_DATA) as NextInvoiceFormData) || {};
  model = linkedSignal(() => {
    return { date: moment(this.data.agreement.NextInvoiceDate) };
  });

  form = form(this.model, (schema) => {
    required(schema.date);
  });

  save() {
    const data = this.form().value();
    this.pending.set(true);
    this.agreementService
      .setNextInvoiceDate(this.data.agreement.AgreementNumber, data.date.format('YYYY-MM-DD'))
      .pipe(finalize(() => this.pending.set(false)))
      .subscribe({
        next: () => {
          this.hostDialog.close(data);
        },
      });
  }
}
